// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid___2dE3g","wrapper":"wrapper___1wTc9"};